import { FunctionComponent } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import NotFound from "./pages/404.jsx";
import LandingPage from "./pages/LandingPage.jsx";
import { useData } from "./providers/ContextProvider.jsx";
import Home from "./pages/Private/Home.jsx";
import Login from "./pages/Login.jsx";
import SetGoals from "./pages/Private/SetGoals";
import AddScore from "./pages/Private/AddScore";
import ViewGoals from "./pages/Private/ViewGoals.jsx";
import Challenges from "./pages/Private/Challenges.jsx";
import Leaderboard from "./pages/Private/Leaderboard.jsx";
import Achievements from "./pages/Private/Achievements.jsx";
import Newsfeed from "./pages/Private/Newsfeed.jsx";
import SignUp from "./pages/SignUp.jsx";
import Blogs from "./pages/Blogs.jsx";
import App from "./App";
import "./styles/general.css";
import "./styles/queries.css";
import "./styles/App.css";

const PrivateRoute: FunctionComponent<{
  path: string;
  children: any;
}> = ({ path, children }) => {
  const {
    state: { isLoggedIn },
  } = useData();
  return isLoggedIn ? (
    children
  ) : (
    <Navigate replace to="/login" state={{ path }} />
  );
};

function EzHabit() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/app" element={<App />}>
          <Route
            path="home"
            element={
              <PrivateRoute path="home">
                <Home />
              </PrivateRoute>
            }
          />
          <Route
            path="set-goals"
            element={
              <PrivateRoute path="set-goals">
                <SetGoals />
              </PrivateRoute>
            }
          />
          <Route
            path="view-goals"
            element={
              <PrivateRoute path="view-goals">
                <ViewGoals />
              </PrivateRoute>
            }
          />
          <Route
            path="add-score"
            element={
              <PrivateRoute path="add-score">
                <AddScore />
              </PrivateRoute>
            }
          />
          <Route
            path="leaderboard"
            element={
              <PrivateRoute path="leaderboard">
                <Leaderboard />
              </PrivateRoute>
            }
          />
          <Route
            path="challenges"
            element={
              <PrivateRoute path="challenges">
                <Challenges />
              </PrivateRoute>
            }
          />
          <Route
            path="achievements"
            element={
              <PrivateRoute path="achievements">
                <Achievements />
              </PrivateRoute>
            }
          />
          <Route
            path="newsfeed"
            element={
              <PrivateRoute path="newsfeed">
                <Newsfeed />
              </PrivateRoute>
            }
          />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default EzHabit;
